import React from 'react'
import 'moment/locale/ko'
import styled from 'styled-components'

// components
import { BoxShadow } from '../../../components/atom'

// styles
import colors from '../../../styles/colors'

// image
import EmptyImg from '../../../assets/image/empty/ic-empty.png'

function Empty({ pointTxt, txt, maxWidth }) {
  return (
    <BoxShadow
      maxWidth={maxWidth ? maxWidth : 768}
      paddingVertical={42}
      paddingHorizontal={10}
    >
      <SelectWrapper>
        <IconWrapper src={EmptyImg} />
        <TextWrapper>
          <span>{pointTxt}</span>
          <span>{txt}</span>
        </TextWrapper>
      </SelectWrapper>
    </BoxShadow>
  )
}

export default Empty

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const IconWrapper = styled.img`
  display: flex;
  margin-bottom: 18px;
  width: 40px;
  height: 40px;
`

const TextWrapper = styled.div`
  font-size: 16px;

  span:nth-child(1) {
    color: ${colors.mainG};
  }

  span:nth-child(2) {
    color: ${colors.BK};
  }

  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`
